import React, { useState, useEffect } from 'react';
import './events.css';
import SecondaryButton from '../../../components/secondaryButton';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventsDocRef = doc(db, 'content', 'supervisionEvents');
        const eventsDoc = await getDoc(eventsDocRef);
        
        if (eventsDoc.exists() && eventsDoc.data().events) {
          setEvents(eventsDoc.data().events);
        }
      } catch (error) {
        console.error('Fejl ved hentning af events:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (isLoading) {
    return <div className="pp-supervision-events-loading">Indlæser events...</div>;
  }

  if (events.length === 0) {
    return null;
  }

  return (
    <div className="pp-supervision-external-events">
      {events.map((event) => (
        <div key={event.id} className="pp-supervision-external-event">
        <div className="pp-supervision-external-event-image">
            <img src={event.imageUrl} alt={event.title} />
        </div>
        <div className="pp-supervision-external-event-content">
            <h2>{event.title}</h2>
            <div 
              className="pp-supervision-external-event-description"
              dangerouslySetInnerHTML={{ __html: event.description }}
            />
            {event.externalLink && (
              <SecondaryButton href={event.externalLink}>
                {event.buttonText || 'Læs mere'}
              </SecondaryButton>
            )}
      </div>
        </div>
      ))}
    </div>
  );
};

export default Events;
